import { useCallback, useEffect } from "react";
import { useAtom } from "jotai";

import { getSettingsRequest } from "pages/SettingsPage/requests";

import { settingsAtom } from "../atoms/settingsAtom";
import { tokenAtom } from "../atoms/accountAtom";

const useInit = () => {
  const [, setSettings] = useAtom(settingsAtom);
  const [, setToken] = useAtom(tokenAtom);

  const getSettings = useCallback(async () => {
    const settingsRes = await getSettingsRequest();

    if (settingsRes && settingsRes.settingsid) {
      setSettings(settingsRes);
    }
  }, []);

  useEffect(() => {
    getSettings().then();

    const tokenFromStorage = localStorage.getItem("token");
    if (tokenFromStorage) {
      setToken(tokenFromStorage);
    }
  }, []);
};

export default useInit;
